import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { BundlesRepositoryService, ConfigurationState, EnumeratedTypesRepositoryService, eOrderType, eOrderTypeGroup, OrderManagerService, OrderRepositoryService, UserGroupAccessRepositoryService } from 'reg-hub-common';
import { EnvironmentUrlService } from '../../services/environment-url/environment-url.service';
import { Router } from '@angular/router';
import { BaseInformationComponent } from '../base-information-component';
import { EagerFetchRepositoryService } from '../../services/eager-fetch-repository/eager-fetch-repository.service';

@Component({
  selector: 'app-base-know-your-customer-information',
  templateUrl: './base-know-your-customer-information.component.html',
  styleUrl: './base-know-your-customer-information.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BaseKnowYourCustomerInformationComponent extends BaseInformationComponent {
  constructor(
    private formBuilder: FormBuilder,
    environmentUrl: EnvironmentUrlService,
    ordersRepo: OrderRepositoryService,
    orderManager: OrderManagerService,
    enumeratedTypesRepo: EnumeratedTypesRepositoryService,
    router: Router,
    configurationState: ConfigurationState,
    eagerFetchService: EagerFetchRepositoryService) { 
      super(environmentUrl, ordersRepo, orderManager, enumeratedTypesRepo, router, configurationState, eagerFetchService); 
    }

  override ngOnInit(): void {
    this.baseOrderDetails = this.formBuilder.group({
      referenceNumber: ['', Validators.required],
      country: ['CA', Validators.required],
      orderTypeID: [eOrderType.knowYourCustomer, Validators.required],
      userGroupID: null,
      bundleID: null
    });

    this.getOrderTypes([eOrderTypeGroup.KnowYourCustomer]);

    super.ngOnInit();
  }

  protected onOrderTypeSelectionChange() {

  }

  protected onCountryChange() {

  }

  protected saveContents() {
    if (this.baseOrderDetails.invalid) {
      this.baseOrderDetails.markAllAsTouched();
      return;
    }

    var orderToCreate = this.baseOrderDetails.getRawValue();
    orderToCreate['knowYourCustomerCriteria'] = {};

    this.ordersRepo.createNewOrder(orderToCreate)
      .subscribe(result => {
        const order = (result as any).resource;
        this.orderManager.updateOrder(order);
        if (order.id) {
          var redirectUrl = ['orders', 'kyc', order.id];
          this.router.navigate(redirectUrl);
        }
      });

  }
}